<template style="width: 100vw;height: 100vw;">
    <div v-if="isMobile == false" class="form-popup" id="confirmation_popup" style="z-index: 9999; display:none;">
        <div class="center-screen">
            <div class="popup-grid" id="confirmation_popup_centered">
                <div v-if="isPrint" class="popup-cell formpopupheader" style="grid-column: col 1 / span 7; grid-row: row 1; color: #FFF;">ПЕЧАТЬ ЗАКАЗА № {{ orderId }}</div>
                <div v-else class="popup-cell formpopupheader" style="grid-column: col 1 / span 7; grid-row: row 1; color: #FFF;">ПОДТВЕРЖДЕНИЕ ЗАКАЗА</div>
                <div class="popup-cell formpopupheader" style="grid-column: col 8 / span 1; grid-row: row 1; text-align: right; padding-right: 2vw">
                    <img id="close_popup_1" class="modal-cancel" src="../assets/IMGS/SVG/cancel.svg" alt="exit" style="cursor: pointer; padding-right: 20px; width:16px;height: 16px;">
                </div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 2; margin-top: 2vw;"><label class="formboldlabel">Заказчик:</label><label class="formnormlabel" id = "customer_last_window">Иван ??????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 3;"><label class="formboldlabel">Пациент:</label><label class="formnormlabel" id = "patient_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 4;" v-show="contactNotEmpty"><label class="formboldlabel">Контактное лицо:</label><label class="formnormlabel" id = "contact_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 3; grid-row: row 5;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 6;"><label class="formboldlabel">Перевозчик:</label><label class="formnormlabel" id = "organisation_name_last_window">Иван Петрович ??</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 7;"><label class="formboldlabel">Транспортное средство:</label><label class="formnormlabel" id = "transport_last_window">Иван Петрович ??</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 3; grid-row: row 8;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 9;"><label class="formboldlabel">Поездка:</label><label class="formnormlabel" id = "way_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 10;"><label class="formboldlabel">Куда доставить:</label><label class="formnormlabel" id = "where_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 11;"><label class="formboldlabel">Откуда забрать:</label><label class="formnormlabel" id = "from_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 12;"><label class="formboldlabel">Когда:</label><label class="formnormlabel" id = "when_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 3; grid-row: row 13;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 14;"><label class="formboldlabel">Комментарий к заказу:</label><label class="formnormlabel" id = "comment_last_window">Иван Петрович ???</label></div>
                <div class="popup-cell popup-breakline" v-show="!isPrint" style="grid-column: col 1 / span 3; grid-row: row 15;"></div>
                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 1 / span 2; grid-row: row 16;"></div>
                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 3 / span 6; grid-row: row 16;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx1" value = "0"/>
                            <label class='box_label' for='popup_chbx1'>
                            <span class='inputlabel_span' ></span>
                            Я даю свое согласие на обработку <a style="padding-left: 5px;" href="/license.pdf" target="_blank">персональных данных</a>
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 1 / span 2; grid-row: row 17;"></div>
                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 3 / span 6; grid-row: row 17;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx2" value = "0"/>
                            <label class='box_label' for='popup_chbx2'>
                            <span class='inputlabel_span' ></span>
                            Подтверждаю, что в случае офомления заказа на третьих лиц, предоставляю персональные данные с их согласия
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 1 / span 2; grid-row: row 18;"></div>
                <div class="popup-cell" v-show="!isPrint" style="grid-column: col 3 / span 6; grid-row: row 18;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx3" value = "0"/>
                            <label class='box_label' for='popup_chbx3'>
                            <span class='inputlabel_span' ></span>
                            Подтверждаю достоверность указанной выше информации, необходимой для выполнения заказа
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" style="display:flex; flex-flow:row; grid-column: col 1 / span 6; grid-row: row 19; text-align: right; margin-top: 2vw; margin-bottom: 1vw; margin-right: 2vw;">
                    <button type="submit" id="close_popup_2" value="Отменить" style="background-color:#98A09F;margin-right:15px;" class="ui-button ui-button--lg ui-button--grey">Отменить</button>
                    <button v-if="!isPrint" type="submit" id="send_order_info" v-on:click="successCallback()" value="Заказать" disabled class="ui-button ui-button--lg ui-button--secondary">Заказать</button>
                    <input v-else type="submit" id="send_order_info" v-on:click="successCallback()" value="Печать" style="height: 45px;" class="ui-button ui-button--lg ui-button--secondary">
                </div>
            </div>
        </div>
    </div>

        <span v-if="isMobile == true" class="form-popup" id="confirmation_popup" style="display: none;">
            <div class="popup-grid" id="confirmation_popup_centered">
                <div v-if="isPrint" class="popup-cell formpopupheader" style="grid-column: col 1 / span 7; grid-row: row 1; color: #FFF;">ПЕЧАТЬ ЗАКАЗА № {{ orderId }}</div>
                <div v-else class="popup-cell formpopupheader" style="grid-column: col 1 / span 7; grid-row: row 1; color: #FFF;">ПОДТВЕРЖДЕНИЕ ЗАКАЗА</div>
                <div class="popup-cell formpopupheader" style="grid-column: col 8 / span 1; grid-row: row 1; text-align: right; padding-right: 2vw">
                    <img id="close_popup_1" class="modal-cancel" src="../assets/IMGS/SVG/cancel.svg" alt="exit" style="cursor: pointer; padding-right: 20px; width:16px;height: 16px;">
                </div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 2; margin-top: 2vw;"><label class="formboldlabel">Заказчик:</label><label class="formnormlabel" id = "customer_last_window">Иван ??????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 3;"><label class="formboldlabel">Пациент:</label><label class="formnormlabel" id = "patient_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 4;" v-show="contactNotEmpty"><label class="formboldlabel">Контактное лицо:</label><label class="formnormlabel" id = "contact_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 3; grid-row: row 5;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 6;"><label class="formboldlabel">Перевозчик:</label><label class="formnormlabel" id = "organisation_name_last_window">Иван Петрович ??</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 7;"><label class="formboldlabel">Транспортное средство:</label><label class="formnormlabel" id = "transport_last_window">Иван Петрович ??</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 4; grid-row: row 8;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 9;"><label class="formboldlabel">Поездка:</label><label class="formnormlabel" id = "way_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 10;"><label class="formboldlabel">Куда доставить:</label><label class="formnormlabel" id = "where_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 11;"><label class="formboldlabel">Откуда забрать:</label><label class="formnormlabel" id = "from_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 12;"><label class="formboldlabel">Когда:</label><label class="formnormlabel" id = "when_last_window">Иван Петрович ?????????</label></div>
                <div class="popup-cell popup-breakline" style="grid-column: col 1 / span 3; grid-row: row 13;"></div>
                <div class="popup-cell" style="grid-column: col 1 / span 8; grid-row: row 14;"><label class="formboldlabel">Комментарий к заказу:</label><label class="formnormlabel" id = "comment_last_window">Иван Петрович ???</label></div>
                <div class="popup-cell popup-breakline" v-show="!isPrint" style="grid-column: col 1 / span 3; grid-row: row 15;"></div>

                <div class="popup-cell" v-show="!isPrint" style="margin-left:25px; grid-column: col 1 / span 8; grid-row: row 16;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx1" value = "0"/>
                            <label class='box_label' for='popup_chbx1'>
                            <span class='inputlabel_span' ></span>
                            <span>Я даю свое согласие на обработку <a style="padding-left: 5px;" href="/license.pdf" target="_blank">персональных данных</a></span>
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" v-show="!isPrint" style="margin-left:25px; grid-column: col 1 / span 8; grid-row: row 17;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx2" value = "0"/>
                            <label class='box_label' for='popup_chbx2'>
                            <span class='inputlabel_span' ></span>
                            Подтверждаю, что в случае офомления заказа на третьих лиц, предоставляю персональные данные с их согласия
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" v-show="!isPrint" style="margin-left:25px; grid-column: col 1 / span 8; grid-row: row 18;">
                    <label class="formtinylabel">
                        <div class="container__input_box">
                            <input class='input_box' type="checkbox" id="popup_chbx3" value = "0"/>
                            <label class='box_label' for='popup_chbx3'>
                            <span class='inputlabel_span' ></span>
                            Подтверждаю достоверность указанной выше информации, необходимой для выполнения заказа
                            </label>
                        </div>
                    </label>
                </div>

                <div class="popup-cell" style="display: flex; flex-flow:column; justify-content:center; align-items:center; grid-column: col 1 / span 8; grid-row: row 19; text-align: right; margin-top: 2vw; margin-bottom: 1vw; margin-right: 2vw;">
                    <button v-if="!isPrint" type="submit" id="send_order_info" v-on:click="successCallback()" value="Заказать" disabled class="ui-button ui-button--sm ui-button--secondary" >Заказать</button>
                    <input v-else type="submit" id="send_order_info" v-on:click="successCallback()" value="Печать" class="ui-button ui-button--sm ui-button--secondary">
                    <button type="submit" id="close_popup_2" value="Отменить" style="background:#98A09F; margin-top: 10px" class="ui-button ui-button--sm ui-button--secondary">Отменить</button>
                </div>
            </div>
        </span>
</template>
  
<script>
    import $ from 'jquery';
    export default {
        name: 'PopupOrderCheckDataWindow',
        props: {
            popupName: String,
            header: String,
            info: String,
            buttonText: String,
            color: String,
            buttonText2: String,
            callback: {
                type: Function,
                default() { return function(){} }
            },
        },
        data() {
            return { 
                isMobile: false,
                isPrint: false, 
                successCallback: function(){}, 
                order_id: 0, 
                contactNotEmpty: false 
            }
        },
        created(){
            this.isMobile = this.getMobileScreen()
        },
        mounted() {
            var vm = this;
            vm.isMobile = this.getMobileScreen()
            document.getElementById("close_popup_1").addEventListener("click", function(){
                vm.closeModal()
            });
            document.getElementById("close_popup_2").addEventListener("click", function(){
                vm.closeModal()
            });
            document.getElementById("popup_chbx1").addEventListener("click", function(){ vm.checkCheckboxes() })
            document.getElementById("popup_chbx2").addEventListener("click", function(){ vm.checkCheckboxes() })
            document.getElementById("popup_chbx3").addEventListener("click", function(){ vm.checkCheckboxes() })
            $("#send_order_info").addClass('blocked');
            document.getElementById("send_order_info").style.background = "#e9ecec";
        },
        methods: {
            getMobileScreen() {
                if (screen.width <= 1024) {
                    return true
                } else {
                    return false
                }
            },
            checkCheckboxes() {
                var button = document.getElementById("send_order_info");
                if (document.getElementById("popup_chbx1").checked &&
                    document.getElementById("popup_chbx2").checked &&
                    document.getElementById("popup_chbx3").checked){
                    button.disabled = false;
                    button.style.background = "#4AACE2"
                    $("#send_order_info").removeClass('blocked')
                    $("#send_order_info").removeAttr('disabled')
                }
                else{
                    button.disabled = true;
                    button.style.background = "#e9ecec"
                    $("#send_order_info").addClass('blocked')
                    $("#send_order_info").attr('disabled', 'disabled')
                }
            },
            setCallback(func) {
                this.successCallback = func
            },
            hideButtons() {
                if (this.isMobile == false) {
                    document.querySelector("#confirmation_popup #close_popup_1").style.display = "none";
                    document.querySelector("#confirmation_popup #close_popup_2").style.display = "none";
                }
                document.querySelector("#confirmation_popup #send_order_info").style.display = "none";
            },
            showButtons() {
                if (this.isMobile == false) {
                    document.querySelector("#confirmation_popup #close_popup_1").style.display = "initial";
                    document.querySelector("#confirmation_popup #close_popup_2").style.display = "initial";
                    document.querySelector("#confirmation_popup #send_order_info").style.display = "initial";
                }
            },
            showModal() {
                document.getElementById("confirmation_popup").style.display = "block";
                this.contactNotEmpty = (document.getElementById("contact_last_window").textContent != "")
                this.showButtons()
                document.body.style.overflow = 'hidden';
            },
            closeModal() {
                document.body.style.overflow = 'scroll';
                document.getElementById("confirmation_popup").style.display = "none";
            },
            setForPrint(isPrint, order_id) {
                this.isPrint = isPrint;
                this.orderId = order_id;
                if (isPrint) {
                    document.querySelector("#confirmation_popup #popup_chbx1").checked = "true"
                    document.querySelector("#confirmation_popup #popup_chbx2").checked = "true"
                    document.querySelector("#confirmation_popup #popup_chbx3").checked = "true"
                    this.checkCheckboxes()
                }
            }
        }
    }
</script>

<style lang="css" scoped src='@/assets/css/dispatcher_orders.css'></style>
<style lang="css" scoped src="@/assets/css/order_data.css"></style>
